import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Rect } from "react-native-svg";

export const IconGiftBox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGiftBox"><Rect x="2" y="4" width="9.25" height="5" fill="currentColor"/><Rect x="3" y="10.5" width="8.25" height="9.5" fill="currentColor"/><Rect x="12.75" y="4" width="9.25" height="5" fill="currentColor"/><Rect x="12.75" y="10.5" width="8.25" height="9.5" fill="currentColor"/></CentralIconBase>;
});

export default IconGiftBox;
